export enum COUNTRY {
    AR = 'AR',
    MX = 'MX',
    ES = 'ES',
    CO = 'CO',
    US = 'US',
    BR = 'BR'
};